import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import "./index.css";
import path from "../../constants/pathConstants";
import { useNavigate } from "react-router-dom";
import { imageBaseUrl } from "../../utils/constants";
export function PageNotFound() {
  const navigate =useNavigate();
  return (
    <div className="page-not-found">
      <img src={`${imageBaseUrl}/NoCaseIcon.png`} alt="ErrorIcon" />
      <p className="page-not-found-title">404 Error</p>
      <p className="page-not-found-title">Page not found</p>
      <button className="page-not-found-btn" data-testid="page-not-found-btn" onClick={() => navigate(path.DASHBOARD)}>Go To Home</button>
    </div>
  );
}

PageNotFound.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const withConnect = connect(
  null,
  mapDispatchToProps
);

export default compose(withConnect)(PageNotFound);
